import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  clearScreenAuthData,
  getScreenAuthData,
  getSessionScreenAuth,
  isScreenSessionExpired,
  persistScreenAuthData,
  syncScreenSessionFromCache,
} from '../utils/screenAuthStorage';

const useScreenAuth = () => {
  const location = useLocation();
  const [state, setState] = useState({
    isAuthenticated: false,
    token: null,
    views: [],
    store_ids: [],
    screen_code: undefined,
    isLoading: true,
  });

  useEffect(() => {
    const resolveAuth = () => {
      let auth = getSessionScreenAuth();
      if (!auth) {
        const cached = getScreenAuthData();
        if (cached?.token) {
          persistScreenAuthData(cached);
          auth = cached;
        }
      }

      if (!auth?.token) {
        setState({
          isAuthenticated: false,
          token: null,
          views: [],
          store_ids: [],
          screen_code: undefined,
          isLoading: false,
        });
        return;
      }

      if (isScreenSessionExpired(auth.expiry_date)) {
        clearScreenAuthData();
        setState({
          isAuthenticated: false,
          token: null,
          views: [],
          store_ids: [],
          screen_code: undefined,
          isLoading: false,
        });
        return;
      }

      setState({
        isAuthenticated: true,
        token: auth.token,
        views: auth.views || [],
        store_ids: auth.store_ids || [],
        screen_code: auth.screen_code,
        isLoading: false,
      });
    };

    resolveAuth();
  }, [location.pathname]);

  return state;
};

export const screenLogout = () => {
  clearScreenAuthData();
  syncScreenSessionFromCache();
};

export default useScreenAuth;
